module.exports = __webpack_public_path__ + "static/media/in.da2ca326.svg";